<template>
  <div style="text-align: center; padding: 100px 0;">
    <img :src="$img.noinfo" style="width: 200px;" />
    <h2 style="margin: 20px 0 10px;">404</h2>
    <p style="color: #999;">抱歉，您访问的页面不存在</p>
    <el-button style="margin-top: 16px;" type="primary" @click="$router.push('/')">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
